module.exports = __webpack_public_path__ + "static/hero-mobility-5a9138a420a77f18244066fa9e9fa8cd.svg";